<button
  #menuTrigger
  type="button"
  class="menu-trigger"
  [attr.aria-expanded]="isOpened()"
  aria-controls="product-category-menu"
  (click)="toggleMenu()"
  (keydown.arrowdown)="$event.preventDefault(); openMenu()"
  (keydown.escape)="closeMenu(true)">
  <app-icon [name]="isOpened() ? 'X' : 'Menu'" size="lg" aria-hidden="true" />
  {{ "common.action.categories" | translate }}
</button>

<ng-template
  [cdkConnectedOverlay]="{
    origin: overlayOrigin(),
    usePopover: 'global',
    matchWidth: true,
    positions: overlayPositions,
    viewportMargin: 16,
    hasBackdrop: true,
    backdropClass: 'category-menu-backdrop',
  }"
  [cdkConnectedOverlayOpen]="isOpened()"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (attach)="onOverlayAttached()"
  (overlayOutsideClick)="closeMenu()"
  (overlayKeydown)="onOverlayKeydown($event)"
  (detach)="closeMenu()">
  <nav
    #menuPanel
    id="product-category-menu"
    class="category-menu"
    cdkTrapFocus
    [attr.aria-label]="'common.action.categories' | translate">
    <div class="category-columns">
      <ul class="root-categories">
        @for (category of categoryList(); track category.id) {
          <li>
            <a
              class="root-category"
              [class.active]="activeCategory().id === category.id"
              routerLink="/products"
              [queryParams]="{ category: category.id }"
              queryParamsHandling="replace"
              (mouseenter)="selectedCategoryId.set(category.id)"
              (focus)="selectedCategoryId.set(category.id)"
              (click)="closeMenu()">
              {{ category.name }}
              @if (category.children.length) {
                <app-icon name="ChevronRight" size="md" aria-hidden="true" />
              }
            </a>
          </li>
        }
      </ul>

      <section id="product-subcategories" class="subcategory-panel" aria-labelledby="active-category-title">
        @if (activeCategory(); as category) {
          <div class="subcategory-heading">
            <div class="category-title">
              @if (category.media; as media) {
                <img class="category-image" [ngSrc]="media | smallestThumbnail" width="64" height="64" [alt]="media.alt ?? ''" />
              }
              <h2 id="active-category-title">
                <a routerLink="/products" [queryParams]="{ category: category.id }" queryParamsHandling="replace" (click)="closeMenu()">
                  {{ category.name }}
                </a>
              </h2>
            </div>
            <a class="view-products" routerLink="/products" [queryParams]="{ category: category.id }" queryParamsHandling="replace" (click)="closeMenu()">
              {{ "common.action.view_all_products" | translate }}
              <app-icon name="ChevronRight" size="sm" aria-hidden="true" />
            </a>
          </div>

          @if (category.children.length) {
            <app-category-menu-groups [groups]="category.children" (navigated)="closeMenu()" />
          } @else {
            <app-category-products-preview [categoryId]="category.id" />
          }
        }
      </section>
    </div>
  </nav>
</ng-template>
